<div class="zesty-modal__backdrop animated fadeIn">
	<div class="zesty-modal__wrapper">
		<div class="zesty-modal">
			<div class="zesty-modal__header">
				<h3 class="zesty-modal__title">{{ data?.options['isReonboard'] ? 'Re-Onboard Accounts' : data?.title }}</h3>
			</div>
			<div class="zesty-modal__content">
				<div class="zesty-table__content">
					<ngx-datatable
						class="zesty__table"
						[rows]="links"
						[loadingIndicator]="false"
						[columnMode]="'force'"
						[headerHeight]="50"
						[footerHeight]="50"
						[rowHeight]="45"
						[scrollbarH]="true"
						[reorderable]="true"
						[limit]="50"
						[sorts]="[{ prop: 'account_name', dir: 'desc' }]"
					>
						<!-- Column Templates -->
						<ngx-datatable-column
							[width]="30"
							[resizeable]="false"
							[sortable]="false"
							[draggable]="false"
							[canAutoResize]="false"
						>
							<ng-template let-row="row" let-expanded="expanded" ngx-datatable-cell-template>
								<span (click)="copyToClipboard(row.link)">
									<i class="far fa-copy cursor-link"></i>
								</span>
							</ng-template>
						</ngx-datatable-column>
						<ngx-datatable-column
							name="Link"
							prop="link"
							[width]="300"
							[resizeable]="false"
							[draggable]="false"
							[canAutoResize]="false"
						>
							<ng-template let-row="row" let-expanded="expanded" ngx-datatable-cell-template>
								<a href="{{ row.link }}" target="_blank">{{ row.link }}</a>
							</ng-template>
						</ngx-datatable-column>
						<ngx-datatable-column
							name="Permissions"
							prop="permissions"
							headerClass="row-center"
							cellClass="row-center"
							[width]="120"
							[resizeable]="false"
							[draggable]="false"
							[canAutoResize]="false"
						></ngx-datatable-column>
						<ngx-datatable-column
							name="Account Name"
							prop="alias"
							[width]="225"
							[resizeable]="false"
							[canAutoResize]="false"
						>
							<ng-template let-row="row" let-expanded="expanded" ngx-datatable-cell-template>
								<input type="text" class="form-control" [(ngModel)]="row.account_name" name="account_name" />
							</ng-template>
						</ngx-datatable-column>
						<ngx-datatable-column name="Role ARN" prop="role_arn" [minWidth]="350" cellClass="arnInput">
							<ng-template let-row="row" let-expanded="expanded" ngx-datatable-cell-template>
								<input type="text" appAutoFocus class="form-control" [(ngModel)]="row.arn" name="arn" />
							</ng-template>
						</ngx-datatable-column>
						<ngx-datatable-column
							name="Valid"
							prop="arnIsValid"
							[width]="60"
							headerClass="row-center"
							cellClass="row-center overflow-auto"
							[resizeable]="false"
							[sortable]="false"
							[draggable]="false"
							[canAutoResize]="false"
						>
							<ng-template let-row="row" let-expanded="expanded" ngx-datatable-cell-template>
								<div class="zesty-status">
									<span
										*ngIf="row.arnInProgress"
										tooltip="Checking..."
										placement="center"
										class="zesty-status__loading"
									></span>
									<span
										*ngIf="row.arnIsValid && !row.arnInProgress"
										tooltip="Valid"
										placement="center"
										class="zesty-status__success"
									></span>
									<span
										*ngIf="!row.arnIsValid && !row.arnInProgress"
										tooltip="Invalid"
										placement="center"
										class="zesty-status__failure"
									></span>
								</div>
							</ng-template>
						</ngx-datatable-column>
						<ngx-datatable-column
							name="Check ARN"
							[width]="110"
							headerClass="row-center"
							cellClass="row-center"
							[resizeable]="false"
							[sortable]="false"
							[draggable]="false"
							[canAutoResize]="false"
						>
							<ng-template let-row="row" let-expanded="expanded" ngx-datatable-cell-template>
								<button class="zesty-table__btn" [disabled]="!row.arn || row.arnInProgress" (click)="checkARN(row)">
									Check ARN
								</button>
							</ng-template>
						</ngx-datatable-column>
					</ngx-datatable>
				</div>
			</div>
			<div class="zesty-modal__actions">
				<span>{{
					!isSameCurBucketName ? 'CUR bucket name should be the same across organisation’s accounts' : ''
				}}</span>
				<div>
					<button class="zesty-modal__close" (click)="closeEvent()">Close</button>
					<button
						class="zesty-modal__create-btn"
						[disabled]="!validArnLinks.length || !isSameCurBucketName"
						(click)="onboardAccounts()"
					>
						{{ data?.options['isReonboard'] ? 'Complete re-onboarding' : 'Onboard accounts' }}
					</button>
				</div>
			</div>
		</div>
	</div>
</div>
